/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitAddUpdateContactRequest } from './MonitAddUpdateContactRequest';
import {
    MonitAddUpdateContactRequestFromJSON,
    MonitAddUpdateContactRequestFromJSONTyped,
    MonitAddUpdateContactRequestToJSON,
} from './MonitAddUpdateContactRequest';

/**
 * 
 * @export
 * @interface MonitRootAddUpdateContactRequest
 */
export interface MonitRootAddUpdateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    cadency?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    contact_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitRootAddUpdateContactRequest
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MonitRootAddUpdateContactRequest
     */
    external_id?: string;
}

/**
 * Check if a given object implements the MonitRootAddUpdateContactRequest interface.
 */
export function instanceOfMonitRootAddUpdateContactRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitRootAddUpdateContactRequestFromJSON(json: any): MonitRootAddUpdateContactRequest {
    return MonitRootAddUpdateContactRequestFromJSONTyped(json, false);
}

export function MonitRootAddUpdateContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitRootAddUpdateContactRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'cadency': !exists(json, 'cadency') ? undefined : json['cadency'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'contact_type': !exists(json, 'contact_type') ? undefined : json['contact_type'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'external_id': !exists(json, 'external_id') ? undefined : json['external_id'],
    };
}

export function MonitRootAddUpdateContactRequestToJSON(value?: MonitRootAddUpdateContactRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'cadency': value.cadency,
        'email': value.email,
        'phone': value.phone,
        'contact_type': value.contact_type,
        'disabled': value.disabled,
        'external_id': value.external_id,
    };
}

